@layer module {
.heading {
            text-align: left;
    }
} // layer module










@layer app {
.radio-button-wrapper {
            margin-bottom: $size-20;
    }

.heading {
            margin-bottom: $size-8;
    }

.heading {
            color: var(--questionnaire-secondary-text);
            font-size: var(--font-size-sm);
            font-weight: normal;
    }
} // layer app
